'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _dec2, _class3, _class4, _temp, _dec3, _dec4, _class5, _class6, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactSlidedown = require('react-slidedown');

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _ = require('../');

var _ScreenedCompanies = require('./ScreenedCompanies.css');

var _ScreenedCompanies2 = _interopRequireDefault(_ScreenedCompanies);

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScreenedCompaniesCard = (_dec = (0, _reactCssModules2.default)(_ScreenedCompanies2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ScreenedCompaniesCard, _Component);

  function ScreenedCompaniesCard(props) {
    (0, _classCallCheck3.default)(this, ScreenedCompaniesCard);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ScreenedCompaniesCard.__proto__ || (0, _getPrototypeOf2.default)(ScreenedCompaniesCard)).call(this, props));

    _this.clickViewMore = function (lbl) {
      var stateLbl = 'viewMore' + lbl;
      var newState = {};
      newState[stateLbl] = !_this.state[stateLbl];
      _this.setState(newState);
    };

    _this.state = {
      viewMoreCo: false,
      viewMoreOg: false,
      viewMoreMc50: false,
      viewMoreUt: false,
      viewMoreFfb: false,
      viewMoreFfi: false,
      viewMoreCl: false
    };
    return _this;
  }
  //


  (0, _createClass3.default)(ScreenedCompaniesCard, [{
    key: 'render',

    //
    value: function render() {
      var _this2 = this;

      //
      var viewMoreTxt = function viewMoreTxt(v) {
        return v ? 'View less' : 'View companies';
      };

      var labels = {
        'co': viewMoreTxt(this.state.viewMoreCo),
        'og': viewMoreTxt(this.state.viewMoreOg),
        'mc50': viewMoreTxt(this.state.viewMoreMc50),
        'ut': viewMoreTxt(this.state.viewMoreUt),
        'ffb': viewMoreTxt(this.state.viewMoreFfb),
        'ffi': viewMoreTxt(this.state.viewMoreFfi),
        'cl': viewMoreTxt(this.state.viewMoreCl)
      };
      //
      var e = this.props.e;
      var icon = this.props.icon;
      //
      var id = e[0];
      var title = e[1];
      var text = e[2];
      var isHi = e[3];
      var hasCompanies = e[4];
      var hasAltSlidedown = e[5];
      var altElem = e[6];
      //
      var uppercaseId = id.charAt(0).toUpperCase() + id.slice(1);
      //
      var label = null;
      var viewMore = null;
      var companies = null;
      if (hasCompanies || hasAltSlidedown) {
        label = labels[id];
        viewMore = this.state['viewMore' + uppercaseId];
      }
      if (hasCompanies) {
        companies = this.props.getCompanies(id);
      }
      //
      if (this.props.clean200 && hasCompanies && companies) {
        return _react2.default.createElement(ScreenedCompaniesTable, { companies: companies });
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'screen-card' },
        _react2.default.createElement('img', {
          styleName: 'screen-icon',
          alt: title,
          src: icon
        }),
        _react2.default.createElement(
          'div',
          { styleName: 'screen-icon-label' },
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'strong',
              { styleName: 'screen-icon-title' },
              title
            ),
            _react2.default.createElement('br', null),
            text
          ),
          isHi ? _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_.LinkIcon, { nospace: true, faclass: 'fa-exclamation-triangle' }),
            '\xA0',
            _react2.default.createElement(
              'b',
              null,
              _react2.default.createElement(
                'i',
                null,
                'HIGHER RISK'
              )
            ),
            _react2.default.createElement('br', null),
            'Investment in these companies automatically earns a fund a fossil fuel grade of C or lower.'
          ) : null,
          hasCompanies || hasAltSlidedown ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'button',
              {
                styleName: 'company-table-button',
                onClick: function onClick() {
                  _this2.clickViewMore(uppercaseId);
                },
                title: label
              },
              label,
              _react2.default.createElement(_.LinkIcon, {
                faclass: viewMore ? 'fa-angle-up' : 'fa-angle-down'
              })
            ),
            _react2.default.createElement(
              _reactSlidedown.SlideDown,
              null,
              hasCompanies && viewMore ? _react2.default.createElement(ScreenedCompaniesTable, { companies: companies }) : null,
              hasAltSlidedown && viewMore ? altElem : null
            )
          ) : altElem
        )
      );
    }
  }]);
  return ScreenedCompaniesCard;
}(_react.Component)) || _class);
var ScreenedCompaniesTable = (_dec2 = (0, _reactCssModules2.default)(_ScreenedCompanies2.default, { allowMultiple: true }), _dec2(_class3 = (_temp = _class4 = function (_Component2) {
  (0, _inherits3.default)(ScreenedCompaniesTable, _Component2);

  function ScreenedCompaniesTable(props) {
    (0, _classCallCheck3.default)(this, ScreenedCompaniesTable);
    return (0, _possibleConstructorReturn3.default)(this, (ScreenedCompaniesTable.__proto__ || (0, _getPrototypeOf2.default)(ScreenedCompaniesTable)).call(this, props));
  }

  (0, _createClass3.default)(ScreenedCompaniesTable, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'table',
        { styleName: 't-table' },
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'th',
              null,
              'Company'
            ),
            _react2.default.createElement(
              'th',
              null,
              'Symbol'
            ),
            _react2.default.createElement(
              'th',
              null,
              'Legal name'
            )
          )
        ),
        _react2.default.createElement(
          'tbody',
          null,
          this.props.companies.map(function (c, i) {
            return _react2.default.createElement(
              'tr',
              { key: 'to_' + i },
              _react2.default.createElement(
                'td',
                null,
                c.short_name
              ),
              _react2.default.createElement(
                'td',
                null,
                c.primary_symbol
              ),
              _react2.default.createElement(
                'td',
                null,
                c.legal_name
              )
            );
          })
        )
      );
    }
  }]);
  return ScreenedCompaniesTable;
}(_react.Component), _class4.propTypes = {
  companies: _react.PropTypes.array.isRequired
}, _temp)) || _class3);
var ScreenedCompanies = (_dec3 = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.company.result,
    searching: state.company.loading,
    searched: state.company.loaded,
    error: state.company.error
  };
}, searchActions), _dec4 = (0, _reactCssModules2.default)(_ScreenedCompanies2.default, { allowMultiple: true }), _dec3(_class5 = _dec4(_class5 = (_temp2 = _class6 = function (_Component3) {
  (0, _inherits3.default)(ScreenedCompanies, _Component3);

  function ScreenedCompanies(props) {
    (0, _classCallCheck3.default)(this, ScreenedCompanies);

    var _this4 = (0, _possibleConstructorReturn3.default)(this, (ScreenedCompanies.__proto__ || (0, _getPrototypeOf2.default)(ScreenedCompanies)).call(this, props));

    _this4.state = {};
    return _this4;
  }

  (0, _createClass3.default)(ScreenedCompanies, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.companies();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.result) {
        var coCompanies = [];
        var ogCompanies = [];
        var mc50Companies = [];
        var utCompanies = [];
        var clCompanies = [];
        props.result.map(function (el) {
          if (el.is_co) coCompanies.push(el);
          if (el.is_og) ogCompanies.push(el);
          if (el.is_f15) mc50Companies.push(el);
          if (el.is_ut) utCompanies.push(el);
          if (el.is_cl) clCompanies.push(el);
          return false;
        });
        var _sorter = function _sorter(a, b) {
          var lbl = 'short_name';
          var a_s = a[lbl].toLowerCase();
          var b_s = b[lbl].toLowerCase();
          return a_s.localeCompare(b_s);
        };
        coCompanies = coCompanies.sort(_sorter);
        ogCompanies = ogCompanies.sort(_sorter);
        mc50Companies = mc50Companies.sort(_sorter);
        utCompanies = utCompanies.sort(_sorter);
        clCompanies = clCompanies.sort(_sorter);
        this.setState({
          coCompanies: coCompanies,
          ogCompanies: ogCompanies,
          mc50Companies: mc50Companies,
          utCompanies: utCompanies,
          clCompanies: clCompanies
        });
      }
    }
    //

  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      if (!this.props.result) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '4.0rem' },
            loaded: false
          })
        );
      }

      var icons = {
        'c2': require('../../../static/images/icn-c2-active-black.svg'),
        'co': require('../../../static/images/icn-co-active-black.svg'),
        'og': require('../../../static/images/icn-og-active-black.svg'),
        'mc50': require('../../../static/images/icn-f5-active-black.svg'), // fix fn
        'ut': require('../../../static/images/icn-ut-active-black.svg'),
        'ffb': require('../../../static/images/icn-ffb-active-black.svg'),
        'ffi': require('../../../static/images/icn-ffi-active-black.svg'),
        'cl': require('../../../static/images/clean-200-icon.png') // fix fn
      };

      var fossilFuelLendingCompanyTable = require('../../../static/images/fossil-fuel-lending-company-table.png');
      var fossilFuelInsuranceCompanyTable = require('../../../static/images/fossil-fuel-insurance-company-table.png');

      var fossilFuelCompaniesConfig = [['c2', 'Top carbon reserve owners', _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          _.Link,
          { xstrong: true, to: _config2.default.links.fficu200, title: 'Carbon Underground 200' },
          'The Carbon Underground 200\u2122'
        ),
        ', compiled and maintained by FFI Solutions, identifies the top 100 coal and the top 100 oil and gas publicly-traded reserve holders globally, ranked by the potential carbon emissions content of their reported reserves.'
      ), 1, // 1 if higher risk,
      0, // 1 if has company table,
      0, // 1 if has alt slidedown,
      _react2.default.createElement(
        'button',
        { styleName: 'company-table-button' },
        _react2.default.createElement(
          _.Link,
          {
            to: _config2.default.links.fficu200,
            title: 'Carbon Underground 200 | FFI Solutions'
          },
          'View companies ',
          _react2.default.createElement(_.LinkIcon, null)
        )
      )], ['co', 'Coal industry', _react2.default.createElement(
        'span',
        null,
        'The coal industry screen consists of companies designated by ',
        _react2.default.createElement(
          _.Link,
          { xstrong: true, to: _config2.default.routes.morningstar, title: 'Morningstar industry classifications' },
          'Morningstar industry classifications'
        ),
        ' as Thermal Coal or Coking Coal; companies from the ',
        _react2.default.createElement(
          _.Link,
          { xstrong: true, to: _config2.default.links.gcel, title: 'Global Coal Exit List' },
          'Global Coal Exit List'
        ),
        ' marked as Mining or Services for Coal Industry Sector; and the top 100 coal reserve holders from the ',
        _react2.default.createElement(
          _.Link,
          { xstrong: true, to: _config2.default.links.fficu200, title: 'Carbon Underground 200' },
          'Carbon Underground 200\u2122'
        ),
        '.'
      ), 0, // 1 if higher risk,
      1, // 1 if has company table,
      0, // 1 if has alt slidedown,
      0], ['og', 'Oil/gas industry', _react2.default.createElement(
        'span',
        null,
        'The oil/gas screen consists of companies designated by ',
        _react2.default.createElement(
          _.Link,
          { xstrong: true, to: _config2.default.routes.morningstar, title: 'Morningstar industry classifications' },
          'Morningstar industry classifications'
        ),
        ' as Oil and Gas Drilling, Oil and Gas Extraction and Production, Oil and Gas Equipment and Services, Oil and Gas Integrated, Oil and Gas Midstream, and Oil and Gas Refining and Marketing; upstream and midstream companies from the ',
        _react2.default.createElement(
          _.Link,
          { xstrong: true, to: _config2.default.links.gogel, title: 'Global Oil/Gas Exit List' },
          'Global Oil/Gas Exit List'
        ),
        '; and the top 100 oil/gas reserve holders from the ',
        _react2.default.createElement(
          _.Link,
          { xstrong: true, to: _config2.default.links.fficu200, title: 'Carbon Underground 200' },
          'Carbon Underground 200\u2122'
        ),
        '.'
      ), 0, // 1 if higher risk,
      1, // 1 if has company table,
      0, // 1 if has alt slidedown,
      0], ['mc50', 'Top coal-fired utilities', _react2.default.createElement(
        'span',
        null,
        'The ',
        _react2.default.createElement(
          _.Link,
          { xstrong: true, to: _config2.default.routes.macroclimate50, title: 'Macroclimate 50\xAE' },
          'Macroclimate\xAE 50'
        ),
        ' is a list of the 50 largest public-company owners of coal-fired power plants in developed markets plus China and India. Macroclimate compiled the list of 50 companies using open-source data on coal-fired power plants worldwide.'
      ), 1, // 1 if higher risk,
      0, // 1 if has company table,
      0, // 1 if has alt slidedown,
      _react2.default.createElement(
        'button',
        { styleName: 'company-table-button' },
        _react2.default.createElement(
          _.Link,
          {
            to: _config2.default.links.fficu200,
            title: 'Macroclimate 50 | Macroclimate'
          },
          'View companies ',
          _react2.default.createElement(_.LinkIcon, null)
        )
      )], ['ut', 'Fossil-fired utilities', _react2.default.createElement(
        'span',
        null,
        'The fossil-fired utilities screen consists of companies designated by ',
        _react2.default.createElement(
          _.Link,
          { xstrong: true, to: _config2.default.routes.morningstar, title: 'Morningstar industry classifications' },
          'Morningstar industry classifications'
        ),
        ' as Utilities-Independent Power Producers, Utilities-Renewable, Utilities-Diversified, Utilities-Regulated Electric, and Utilities-Regulated Gas. (Despite the name, the Utilities-Renewable industry classification includes companies that distribute gas and/or burn fossil fuel for power generation.) It also includes companies from the ',
        _react2.default.createElement(
          _.Link,
          { xstrong: true, to: _config2.default.links.gcel, title: 'Global Coal Exit List' },
          'Global Coal Exit List'
        ),
        ' marked as Power for Coal Industry Sector. We remove any companies in these categories that are engaged in 100% renewable operations, pure transmission, or otherwise don\'t distribute gas or burn fossil fuels to generate power. We also remove a small number of utilities that have fossil fuel operations but meet the criteria for inclusion on our Clean200 screen - USD revenue of at least $1 billion, and over 50% of total revenues are from green sources, as measured by Corporate Knights Research.'
      ), 0, // 1 if higher risk,
      1, // 1 if has company table,
      0, // 1 if has alt slidedown,
      0]];

      var fossilFinanceCompaniesConfig = [['ffb', 'Fossil fuel finance', _react2.default.createElement(
        'span',
        null,
        'The fossil fuel finance screen consists of 60 of the largest commercial and investment banks, from the ',
        _react2.default.createElement(
          _.Link,
          {
            to: 'https://www.bankingonclimatechaos.org/',
            title: 'Banking on Climate Chaos',
            xstrong: true
          },
          'Banking on Climate Chaos'
        ),
        ' report. The data tracks the total fossil fuel financing of these banks over 2016-2023: lending, and underwriting debt and equity issuances. For our fund ratings, we normalize the bank financing amounts from $USD to a 0-10 scale, where 10 is the worst score possible. These 0-10 figures represent a ',
        _react2.default.createElement(
          'b',
          null,
          'company fossil fuel finance risk score'
        ),
        '.'
      ), 0, // 1 if higher risk,
      0, // 1 if has company table,
      1, // 1 if has alt slidedown,
      _react2.default.createElement(
        'div',
        { styleName: 'finance-company-table-img-wrap' },
        _react2.default.createElement('img', {
          src: fossilFuelLendingCompanyTable,
          alt: 'Fossil fuel finance company table',
          styleName: 'finance-company-table-img'
        })
      )], ['ffi', 'Fossil fuel insurance', _react2.default.createElement(
        'span',
        null,
        'The fossil fuel insurance screen consists of 30 of the largest primary insurers and reinsurers, from the ',
        _react2.default.createElement(
          _.Link,
          {
            to: 'https://docs.google.com/spreadsheets/d/157kNo3-xg7qeVHi8SF21VqjXKrSjHixL9UOKFTp8PKQ/edit#gid=769793980',
            title: 'Insure Our Future Scorecard',
            xstrong: true
          },
          'Insure Our Future Scorecard'
        ),
        '. The data rates the fossil fuel insurance policies of these companies. For our fund ratings, we normalize the insurance policy ratings to a 0-10 scale, where 10 is the worst score possible. These 0-10 figures represent a ',
        _react2.default.createElement(
          'b',
          null,
          'company fossil fuel insurance risk score'
        ),
        '.'
      ), 0, // 1 if higher risk,
      0, // 1 if has company table,
      1, // 1 if has alt slidedown,
      _react2.default.createElement(
        'div',
        { styleName: 'finance-company-table-img-wrap' },
        _react2.default.createElement('img', {
          src: fossilFuelInsuranceCompanyTable,
          alt: 'Fossil fuel insurance company table',
          styleName: 'finance-company-table-img'
        })
      )]];

      var cleanEnergyCompaniesConfig = [['cl', 'Clean energy leaders', _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          _.Link,
          { xstrong: true, to: _config2.default.routes.clean200, title: 'Clean200' },
          'The Clean200'
        ),
        ' are the largest 200 public companies ranked by green energy revenues. The dataset is developed by multiplying a company\u2019s most recent year-end revenues by its clean revenue estimate, primarily sourced from Corporate Knights Research supplemented by FactSet, Bloomberg BNEF, and FTSE Russell data. In order to be eligible, a company must have USD revenue of at least $1 billion (most recent available fiscal year-end data) and earn more than 10% of total revenues from clean sources, which extends beyond energy efficiency, green energy, and zero emission and hybrid vehicles. We include banks that are financing the low-carbon solutions; real estate companies leading the way on low-carbon buildings; forestry companies protecting carbon sinks; responsible miners of critical materials for the low carbon economy; food and apparel companies with products that are primarily made of raw materials with a significantly lower carbon footprint; and energy-hungry information and communications technology companies that are leading the way on renewable energy. A small number of utilities that have fossil fuel operations but have over 50% of total revenue from green sources are included. The Clean200 was created by As You Sow and Corporate Knights.'
      ), 0, // 1 if higher risk,
      1, // 1 if has company table,
      0, // 1 if has alt slidedown,
      0]];

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'main-wrap' },
        !this.props.clean200 ? _react2.default.createElement(
          'div',
          null,
          fossilFuelCompaniesConfig.map(function (e, i) {
            return _react2.default.createElement(ScreenedCompaniesCard, {
              k: 'screened-company-card-' + i + '-0',
              e: e,
              icon: icons[e[0]],
              getCompanies: function getCompanies(id) {
                return _this5.state[id + 'Companies'];
              }
            });
          }),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'p',
            { styleName: 'p' },
            'We also search for investments in financial industry companies that are financing and insuring the fossil fuel industry. ',
            _react2.default.createElement(
              _.Link,
              {
                to: _config2.default.routes.banksInsurance,
                title: 'Fossil fuel finance & insurance',
                xstrong: true
              },
              'Read more',
              _react2.default.createElement(_.LinkIcon, null)
            )
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          fossilFinanceCompaniesConfig.map(function (e, i) {
            return _react2.default.createElement(ScreenedCompaniesCard, {
              k: 'screened-company-card-' + i + '-1',
              e: e,
              icon: icons[e[0]],
              getCompanies: function getCompanies(id) {
                return _this5.state[id + 'Companies'];
              }
            });
          }),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'p',
            { styleName: 'p' },
            'We also search for investments in companies that are leading the way with solutions for the transition to clean energy. ',
            _react2.default.createElement(
              _.Link,
              {
                to: _config2.default.routes.clean200,
                title: 'Clean200',
                xstrong: true
              },
              'Read more',
              _react2.default.createElement(_.LinkIcon, null)
            )
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null)
        ) : null,
        _react2.default.createElement('div', { styleName: 'anchor', id: 'clean200' }),
        cleanEnergyCompaniesConfig.map(function (e, i) {
          return _react2.default.createElement(ScreenedCompaniesCard, {
            k: 'screened-company-card-' + i + '-2',
            e: e,
            icon: icons[e[0]],
            getCompanies: function getCompanies(id) {
              return _this5.state[id + 'Companies'];
            },
            clean200: _this5.props.clean200
          });
        })
      );
    }
  }]);
  return ScreenedCompanies;
}(_react.Component), _class6.propTypes = {
  searching: _react.PropTypes.bool,
  searched: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.array
}, _temp2)) || _class5) || _class5);
exports.default = ScreenedCompanies;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ScreenedCompanies/ScreenedCompanies.js
// module id = 1388
// module chunks = 0